import React from "react";
import gamersLogo from "../../assets/images/gamerslogo.png";
import ticTokIcon from "../../assets/socials/tictok.png";
import twitchIcon from "../../assets/socials/twitchIcon.png";
import twitterIcon from "../../assets/socials/twitterIcon.png";
import instagramIcon from "../../assets/socials/instagramIcon.png";
import facebookIcon from "../../assets/socials/facebookIcon.png";
import discordIcon from "../../assets/socials/discordIcon.png";
import youtubeIcon from "../../assets/socials/youtubeIcon.png";
import streamIcon from "../../assets/socials/streamIcon.png";
import redditIcon from "../../assets/socials/redditIcon.png";
import telegramIcon from "../../assets/socials/telegramIcon.png";
import "./Footer.css";
import { useTranslation } from "react-i18next";
const Footer = () => {
  const { t } = useTranslation();
  return (
    <div className="footer-container">
      <div className="footer-details">
        <div className="footer-logo-text">
          <img src={gamersLogo} alt="Sportrex Footer Logo" />
          <h5>
            {t("A")} {t("Decentralized")} {t("wallet")} {t("dedicated")} <br />{" "}
            {t("to")} {t("Gamers")}.
          </h5>
        </div>
        <div className="footer-links">
          <h5>{t("Navigation")}</h5>
          <ul>
            <li>
              <a
                href="https://www.sportrex.io/"
                target="_blank"
                rel="noreferrer"
              >
                {t("Home")}
              </a>
            </li>
            <li>
              <a
                href="https://medium.com/@sportrex"
                target="_blank"
                rel="noreferrer"
              >
                {t("Blog")}
              </a>
            </li>
            <li>
              <a href="#trade">{t("Features")}</a>
            </li>
          </ul>
        </div>
        <div className="footer-links">
          <h5>{t("Products")}</h5>
          <ul>
            <li>
              <a href="/">Gamers Wallet</a>
            </li>
            <li>
              <a
                href="https://nftmarketplace.sportrex.io/"
                target="_blank"
                rel="noreferrer"
              >
                NFT {t("Marketplace")}
              </a>
            </li>
          </ul>
        </div>
        <div className="footer-links">
          <h5>{t("Legal")}</h5>
          <ul>
            <li>
              <a
                href="https://media.publit.io/file/SportrexPrivacyPOLICY.pdf"
                target="_blank"
                rel="noreferrer"
              >
                {t("Privacy")} {t("Policy")}
              </a>
            </li>
            <li>
              <a
                href="https://media.publit.io/file/SportrexPrivacyPOLICY.pdf"
                target="_blank"
                rel="noreferrer"
              >
                {t("Terms")} {t("of")} {t("Service")}
              </a>
            </li>
            <li>
              <a href="/faq">FAQ</a>
            </li>
          </ul>
        </div>
        <div className="footer-socials">
          <a
            href="https://vm.tiktok.com/ZM8KVx1gb/"
            target="_blank"
            rel="noreferrer"
          >
            <img src={ticTokIcon} alt="Sportrex Ticktok Icon" />
          </a>
          <a
            href="https://www.twitch.tv/sportrexofficial"
            rel="noreferrer"
            target="_blank"
          >
            <img src={twitchIcon} alt="Sportrex Twitch Icon" />
          </a>
          <a
            href="https://twitter.com/sportrexhq"
            target="_blank"
            rel="noreferrer"
          >
            <img src={twitterIcon} alt="Sportrex Twitter Icon" />
          </a>
          <a
            href="https://instagram.com/sportrexofficial"
            rel="noreferrer"
            target="_blank"
          >
            <img src={instagramIcon} alt="Sportrex Instagram Icon" />
          </a>
          <a
            href="https://www.facebook.com/sportrexofficial"
            rel="noreferrer"
            target="_blank"
          >
            <img src={facebookIcon} alt="Sportrex Facebook Icon" />
          </a>
          <a
            href="https://discord.gg/QMqmznUvq2"
            target="_blank"
            rel="noreferrer"
          >
            <img src={discordIcon} alt="Sportrex Discord Icon" />
          </a>
          <a
            href="https://www.youtube.com/channel/UCD-fhKSFYxU4em8mouCunEA"
            rel="noreferrer"
            target="_blank"
          >
            <img src={youtubeIcon} alt="Sportrex Youtube Icon" />
          </a>
          <a href="##" target="_blank">
            <img src={streamIcon} alt="Sportrex Stream Icon" />
          </a>
          <a
            href="https://www.reddit.com/r/Sportrexofficial/"
            rel="noreferrer"
            target="_blank"
          >
            <img src={redditIcon} alt="Sportrex Reddit Icon" />
          </a>
          <a
            href="https://t.me/sportrexofficial"
            target="_blank"
            rel="noreferrer"
          >
            <img src={telegramIcon} alt="Sportrex Telegram Icon" />
          </a>
        </div>
      </div>
      <div className="footer-copyright">
        <hr />
        <p>© {new Date().getFullYear()} Sportrex Inc.</p>
      </div>
    </div>
  );
};

export default Footer;
